"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Akord = void 0;
const akord_api_1 = require("./api/akord-api");
const crypto_1 = require("@akord/crypto");
const constants_1 = require("./constants");
const logger_1 = require("./logger");
const memo_1 = require("./core/memo");
const folder_1 = require("./core/folder");
const membership_1 = require("./core/membership");
const vault_1 = require("./core/vault");
const stack_1 = require("./core/stack");
const note_1 = require("./core/note");
const manifest_1 = require("./core/manifest");
const profile_1 = require("./core/profile");
const cacheable_1 = require("./types/cacheable");
const batch_1 = require("./core/batch");
const contract_1 = require("./core/contract");
const nft_1 = require("./core/nft");
const collection_1 = require("./core/collection");
const zip_1 = require("./core/zip");
const file_1 = require("./core/file");
const plugin_1 = require("./plugin");
const storage_1 = require("./core/storage");
class Akord {
    /**
     * @param  {ClientConfig} config
     * @param  {Wallet} [wallet]
     */
    constructor(wallet, config = {}) {
        this.api = config.api ? config.api : new akord_api_1.AkordApi(config);
        this.wallet = wallet;
        this.env = config.env || 'v2';
        crypto_1.Crypto.configure({ wallet: wallet });
        plugin_1.Plugins.register(config.plugins, this.env);
        logger_1.Logger.debug = config.debug;
        logger_1.Logger.logToFile = config.logToFile;
        cacheable_1.CacheBusters.cache = config.cache;
    }
    get memo() {
        return new memo_1.MemoModule(this.wallet, this.api);
    }
    get folder() {
        return new folder_1.FolderModule(this.wallet, this.api);
    }
    get membership() {
        return new membership_1.MembershipModule(this.wallet, this.api);
    }
    get vault() {
        return new vault_1.VaultModule(this.wallet, this.api);
    }
    get stack() {
        return new stack_1.StackModule(this.wallet, this.api);
    }
    get note() {
        return new note_1.NoteModule(this.wallet, this.api);
    }
    get manifest() {
        return new manifest_1.ManifestModule(this.wallet, this.api);
    }
    get profile() {
        return new profile_1.ProfileModule(this.wallet, this.api);
    }
    get batch() {
        return new batch_1.BatchModule(this.wallet, this.api);
    }
    get contract() {
        return new contract_1.ContractModule(this.wallet, this.api);
    }
    get nft() {
        return new nft_1.NFTModule(this.wallet, this.api);
    }
    get collection() {
        return new collection_1.CollectionModule(this.wallet, this.api);
    }
    get file() {
        return new file_1.FileModule(this.wallet, this.api);
    }
    get zip() {
        return new zip_1.ZipModule(this.wallet, this.api);
    }
    get storage() {
        return new storage_1.StorageModule(this.wallet, this.api);
    }
}
exports.Akord = Akord;
Akord.reactionEmoji = constants_1.reactionEmoji;
